export default "__VITE_ASSET__3b53cba3__"